<template>
  <div>
    <v-card :outlined="outlined">
      <v-card-title class="subheading">
        {{ deadline.title }}
        <v-spacer></v-spacer>
        <v-chip label small>
          <v-icon left small>mdi-sort-numeric-ascending</v-icon
          >{{ deadline.sortKey }}
        </v-chip>
      </v-card-title>
      <v-card-subtitle>{{ deadline.description }}</v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="mb-1">
                    <span
                      v-if="
                        deadline.availableLabels &&
                        deadline.availableLabels.length > 0
                      "
                    >
                      <v-chip
                        small
                        outlined
                        v-for="(label, index) in deadline.availableLabels"
                        :key="index"
                        class="py-0 mb-0 my-1 mr-1"
                      >
                        {{ label }}
                      </v-chip>
                    </span>
                    <span v-else
                      ><v-chip outlined small class="py-0 mb-0 my-1">
                        Keine Labels definiert</v-chip
                      ></span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Anwendbare Labels
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <!-- <v-col cols="12">
                          <v-card outlined>
                            <v-list-item
                              @click="showPersonTable = !showPersonTable"
                            >
                              <v-list-item-content>
                                <v-list-item-subtitle
                                  >Anwendbar auf Abteilungen
                                  <small
                                    >({{
                                      deadline.applicableTo.divisionIds.length
                                    }})</small
                                  ></v-list-item-subtitle
                                >
                              </v-list-item-content>
                              <v-list-item-action
                                ><v-btn depressed icon small>
                                  <v-icon
                                    >{{
                                      showPersonTable
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                    }}
                                  </v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                            <v-expand-transition>
                              <div v-show="showPersonTable">
                                <v-divider></v-divider>
                                <v-data-table
                                  :headers="personTableHeaders"
                                  :items="deadline.persons"
                                  multi-sort
                                  group-by="user.division.title"
                                  item-key="user.uid"
                                  sort-by="user.displayName"
                                  :sort-desc="false"
                                  dense
                                  :items-per-page="25"
                                  :footer-props="{
                                    'items-per-page-options': [25, 50, 100, -1],
                                  }"
                                  :mobile-breakpoint="0"
                                >
                                  <template
                                    v-slot:[`group.header`]="{
                                      items,
                                      isOpen,
                                      toggle,
                                    }"
                                  >
                                    <th
                                      :colspan="batchData.persons.length + 1"
                                      class="group-header-th"
                                    >
                                      <v-icon @click="toggle" class="mr-2"
                                        >{{
                                          isOpen
                                            ? "mdi-chevron-up"
                                            : "mdi-chevron-down"
                                        }}
                                      </v-icon>
                                      <span>
                                        {{ items[0].user.division.title }}
                                      </span>
                                    </th>
                                  </template>
                                </v-data-table>
                              </div>
                            </v-expand-transition>
                          </v-card>
                        </v-col> -->
          <v-col cols="12" sm="6" md="6">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{
                    getDueTypeText(deadline.dueType)
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Fristablauf</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ deadline.defaultInterval.value }}
                    {{
                      getIntervalText(deadline.defaultInterval.unit)
                    }}</v-list-item-title
                  >
                  <v-list-item-subtitle>Standardintervall</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{
                    getUpdatePolicyText(deadline.updatePolicy)
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    Aktualisierungsrichtlinie für
                    Fristeneinträge</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "deadline-detail-card",
  components: {},
  props: {
    deadline: {
      type: Object,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    getIntervalText(unit) {
      const intervalValues = [
        { text: "Tage", value: "days" },
        { text: "Wochen", value: "weeks" },
        { text: "Monate", value: "months" },
        { text: "Jahre", value: "years" },
      ];

      const found = intervalValues.find((interval) => interval.value === unit);
      return found ? found.text : "Unbekannte Einheit";
    },
    getDueTypeText(dueType) {
      const deadlineTypeValues = [
        { text: "Taggenaue Fälligkeit", value: "day" },
        { text: "Fälligkeit zum Monatsende", value: "month-end" },
        { text: "Fälligkeit zum Quartalsende", value: "quarter-end" },
        { text: "Fälligkeit zum Halbjahresende", value: "halfyear-end" },
        { text: "Fälligkeit zum Jahresende", value: "year-end" },
      ];

      const found = deadlineTypeValues.find((type) => type.value === dueType);
      return found ? found.text : "Unbekannter Typ";
    },
    getUpdatePolicyText(updatePolicy) {
      const updatePolicyValues = [
        {
          text: "Keine Berechtigung zur Aktualisierung des eigenen Fristenstatus",
          value: "noUpdate",
        },
        {
          text: "Berechtigung, Aktualisierungen am eigenen Fristenstatus vorzuschlagen (Genehmigungsprozess erforderlich)",
          value: "proposeUpdate",
        },
        {
          text: "Berechtigung, eigenen Fristenstatus selbst zu aktualisieren",
          value: "selfUpdate",
        },
      ];

      const found = updatePolicyValues.find(
        (policy) => policy.value === updatePolicy
      );
      return found ? found.text : "Unbekannte Richtlinie";
    },
  },
};
</script>
